import { Observable } from "rxjs";
import {
    BRAND_GUEST_BUYER_WHITELIST_PRODUCT_VALUES_UPDATE,
    BRAND_GUEST_BUYER_WHITELIST_PRODUCT_VALUES_UPDATE_COMPLETED,
} from "constants/action-types";
import siteConfig from "site-config";
import { formatMessage } from "lib/globalize-util";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { add as snackbarAdd } from "actions/snackbars";

export const updateGuestBuyerWhitelistProductValues = (action$, store) => {
    return action$
        .ofType(BRAND_GUEST_BUYER_WHITELIST_PRODUCT_VALUES_UPDATE)
        .map((action) => {
            return action.payload;
        })
        .concatMap((values) => {
            const { brand } = store.getState().scope;
            const data = {
                settings: {
                    ...brand.settings,
                    guest_buyer_product_whitelist_values: values.length > 0 ? values : [],
                },
            };
            return ajax({
                method: "POST",
                body: data,
                url: `${siteConfig.api}/brand/info/update`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(
                                snackbarAdd({
                                    message: formatMessage("Error saving guest buyer whitelist product values"),
                                })
                            ),
                            {
                                payload: [],
                                error: true,
                                type: BRAND_GUEST_BUYER_WHITELIST_PRODUCT_VALUES_UPDATE_COMPLETED,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                type: BRAND_GUEST_BUYER_WHITELIST_PRODUCT_VALUES_UPDATE_COMPLETED,
                            },
                            snackbarAdd({ message: formatMessage("Guest Buyer Whitelist Product Values Updated") }),
                        ];
                    }
                })
                .catch((error) => {
                    let errorMessage = formatMessage("Error saving guest buyer whitelist product values");
                    if (error.status === 401) {
                        errorMessage = formatMessage("You do not have permission to edit guest buyer whitelist values");
                    }
                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRAND_GUEST_BUYER_WHITELIST_PRODUCT_VALUES_UPDATE_COMPLETED,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage }))
                    );
                });
        });
};
